<template>
  <div class="wordstat-container">
    <!-- Основной контент -->
    <div>
      <!-- Общий прелоадер (только при загрузке, не при отсутствии данных) -->
      <div v-if="loading && !calcloaded" class="text-center py-5">
        <individual-preloader :loading="true" />
      </div>

      <!-- Карточка: График Wordstat -->
      <div v-if="calcloaded && (graphData.chartData.datasets !== null)" class="data-section mb-4" id="wordstat-chart">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h3 class="section-title">Статистика по спросу в Wordstat за период {{getperiod}}</h3>
          <download-multiselect-button v-if="calcloaded" :downloadReportType="downloadReportType" :urls="[wordstatDownloadLink]" class="align-to-right" :chartContainerSelector="'#wordstat-chart'" chartType="wordstat"></download-multiselect-button>
        </div>

        <div class="wordstat__filters d-flex flex-wrap mb-3">
          <div class="usp__filter">
            <input type="radio" id="week" value="WEEK" name="period" v-model="wordstatPeriodTypeModel">
            <label for="week">Недели</label>
          </div>
          <div class="usp__filter">
            <input type="radio" id="month" value="MONTH" name="period" v-model="wordstatPeriodTypeModel">
            <label for="month">Месяцы</label>
          </div>
        </div>

        <div class="chart-container">
          <transition name="chart-fade">
            <line-chart
              v-if="calcloaded"
              :chartData="graphData.chartData"
              :options="options"
              :animation-type="'slow'"
              :styles="myStyles"
              :type="type"
              :key="componentLineChartKey"
              class="line-chart-mr-bottom"
            />
          </transition>
          <individual-preloader :loading="loading"/>
        </div>

        <div v-if="calcloaded && (graphData.chartData.datasets !== null)" class="d-flex flex-wrap container-legend">
          <div v-for="(item, index) in graphData.chartData.datasets" :id="'container-element-' + index" class="container-legend-element" @click="hideOneDataset(index)">
            <div class="line" :style="{'color': chartColours[index], 'opacity': item.hidden ? 0.5 : 1}">
              <p :style="{'opacity': item.hidden ? 0.5 : 1}">{{item.label}}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Карточка: Таблица результатов -->
      <div v-if="calcloaded && (getWordstatBrand || getWordstatCategory || getWordstatCombined) && graphData.fields.length > 1 && (graphData.chartData.datasets !== null)" class="data-section mb-4">
        <h3 class="section-title mb-3">Табличные данные</h3>
        <results-table :fields="graphData.fields" :items="graphData.items" :key="componentTableKey" class="results-table"/>
      </div>

      <!-- Сообщение об ошибке на сером фоне -->
      <div v-if="(!calcloaded && !loading) || (calcloaded && graphData.chartData.datasets === null)" class="d-flex justify-content-center flex-wrap py-5">
        <div class="error">
          <img :src="require(`../../img/error.svg`)" alt="error" class="error__image__left">
          За выбранный период данные отсутствуют
          <img :src="require(`../../img/error.svg`)" alt="error" class="error__image__right">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LineChart from './WSLineChart.vue'
import ResultsTable from "./WSTableResults";
import DownloadButton from "../common/DownloadButton";
import DownloadMultiselectButton from "../common/DownloadMultiselectButton";
import EventHubListenerMixin from "../common/mixins/EventHubListener";
import {mapActions, mapGetters} from "vuex";
import Preloader from "../common/Preloader";
import IndividualPreloader from "../common/IndividualPreloader";

export default {
  name: 'LineChartContainer',
  components: { LineChart, ResultsTable, EventHubListenerMixin, DownloadButton, DownloadMultiselectButton, Preloader, IndividualPreloader },
  data: () => ({
    componentLineChartKey: false,
    componentTableKey: false,
    chartData: null,
    fields: null,
    fullChartItems: null,
    fullChartFields: null,
    items: null,
    advertisersLabels: [],
    chartColours: [],
    downloadReportType: "export-wordstat"
  }),
  computed: {
    ...mapGetters("wordstat", ["cloaded", "loading", "wordstatReport", "wordstatPeriod", "getWordstatBrand", "getWordstatCategory", "getWordstatCombined", "getFullChartFields", "getFullChartItems", "wordstatDownloadLink"]),
    ...mapGetters('filters', ["dateRange", 'dateRangeString']),

    calcloaded() {
       return this.cloaded
    },
    graphData() {
      return this.setGraphData();
    },
    myStyles () {
      return {
        responsive: true
      }
    },
    type(){
      return { type: 'line'}
    },
    getperiod() {
      return `c ${this.dateRange.startDate.toISOString().substring(0, 10).split("-").reverse().join(".")} по ${this.dateRange.endDate.toISOString().substring(0, 10).split("-").reverse().join(".")}`
    },
    options() {
      return {
          responsive: true,
          maintainAspectRatio: false,
          height: 200,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                type: 'linear',
                display: true,
                position: 'left',
                gridLines: {
                  color: '#EBEDF3',
                  display: true,
                  circular: true,
                  borderDash: [8, 8],
                  zeroLineWidth: 1,
                  zeroLineColor: '#EBEDF3',
                },
                ticks: {
                  precision: 0,
                  beginAtZero: false
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  fontSize: 14,
                  fontColor: '#6C757D',
                  fontStyle: 700,
                  fontWeight: 700,
                },
                gridLines: {
                  color: '#EBEDF3',
                  display: true,
                  circular: true,
                  borderDash: [8, 8],
                  zeroLineWidth: 0,
                },
                ticks: {
                  min: 1,
                  stepSize: 1,
                  max: 100,
                  beginAtZero: false,
                  maxRotation: 45,
                  minRotation: 45,
                  callback: function (value, index, values) {
                    if (index === 0 || index === values.length) {
                      return ""
                    }
                    return value
                  },
                },
              }
            ]
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false
            },
            title: {
              display: true,
              text: 'Chart.js Line Chart'
            },
            labels: {
                // This more specific font property overrides the global property
                font: {
                    family: 'Roboto',
                    size: 14
                }
            },
          },

          elements: {
            line: {
              fill: true,
              tension: 0.2,  // Увеличиваем плавность линии (0.4 вместо 0)
              borderWidth: 3
            },
            point: {
                radius: 0,
                hitRadius: 8,
                hoverRadius: 4,
                pointStyle: 'circle',
                backgroundColor: (context) => {
                  const dataSetIndex = context.datasetIndex;
                  this.randomColour = this.chartColours[dataSetIndex]
                  return this.randomColour;
                },
                borderColor: (context) => {
                  const dataSetIndex = context.datasetIndex;
                  this.randomColour = this.chartColours[dataSetIndex]
                  return this.randomColour;
                },
                borderWidth: 2
            }
          },
        }
    },

    wordstatPeriodTypeModel: {
      get() {
        return this.wordstatPeriod;
      },
      set(val) {
        this.selectPeriodType(val)
        this.fetchWordstat();
      }
    },

  },

  async mounted() {
    this.setGraphData();

    this.$nextTick(() => {
      if (this.graphData && this.graphData.chartData && this.graphData.chartData.datasets) {
        this.setInitialActiveState();
        this.updateChartVisibility();
      }
    });
  },

  methods: {
    updateChartVisibility() {
      if (this.graphData && this.graphData.chartData && this.graphData.chartData.datasets) {
        this.graphData.chartData.datasets.forEach((dataset, index) => {
          this.updateLegendVisualState(index, dataset.hidden);
        })
      }

      this.componentLineChartKey = !this.componentLineChartKey
    },

    hideOneDataset(indexDataset) {
      const dataset = this.graphData.chartData.datasets[indexDataset];
      const label = dataset.label;

      dataset.hidden = !dataset.hidden;

      // Обновляем состояние hidden в полях таблицы
      const tableField = this.graphData.fields.find(field => field.label === label);
      if (tableField) {
        tableField.hidden = dataset.hidden;
      }

      if (label === 'Общие данные') {
        this.selectWordstatCombined(!dataset.hidden);
      } else if (label === 'General') {
        this.selectWordstatCategory(!dataset.hidden);
      } else {
        const hasVisibleBrands = this.graphData.chartData.datasets.some(ds =>
          ds.label !== 'Общие данные' && ds.label !== 'General' && !ds.hidden
        );
        this.selectWordstatBrand(hasVisibleBrands);
      }

      this.componentLineChartKey = !this.componentLineChartKey;
      this.componentTableKey = !this.componentTableKey;
    },

    getRandomColor(advertiser_number, advertiser_type) {
          const COMBINED_COLOR = "#3B2CDD";
          const CATEGORY_COLOR = "#FF9F40";

          const brandColors = [
            '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
            '#22C55E', '#F59E0B', '#C9CBCF', '#8B5CF6', '#EF4444'
          ];

          if (advertiser_type === "category") {
            return CATEGORY_COLOR;
          } else if (advertiser_type === "brand") {
            return brandColors[advertiser_number % brandColors.length];
          } else if (advertiser_type === "combined") {
            return COMBINED_COLOR;
          } else {
            return brandColors[advertiser_number % brandColors.length];
          }
        },

    getTableResult(labels, advertisers) {
        let fields = []
        let items = []

        let combinedAdvertiser = null;
        let categoryAdvertiser = null;
        let brandAdvertisers = [];

        for (let i = 0; i < advertisers.length; i++) {
          const advertiser = advertisers[i];
          if (advertiser.id === "combined") {
            combinedAdvertiser = { ...advertiser, index: i };
          } else if (advertiser.id === null) {
            categoryAdvertiser = { ...advertiser, index: i };
          } else {
            const totalShows = advertiser.series.reduce((sum, value) => sum + (value || 0), 0);
            brandAdvertisers.push({
              ...advertiser,
              index: i,
              totalShows: totalShows
            });
          }
        }

        brandAdvertisers.sort((a, b) => b.totalShows - a.totalShows);
        const topBrandAdvertisers = brandAdvertisers.slice(0, 10);

        const finalAdvertisers = [];

        if (combinedAdvertiser) {
          finalAdvertisers.push(combinedAdvertiser);
        }

        if (categoryAdvertiser) {
          finalAdvertisers.push(categoryAdvertiser);
        }

        finalAdvertisers.push(...topBrandAdvertisers);

        // Вычисляем топ-3 для таблицы (такая же логика как в графике)
        const advertisersWithTotals = [];
        for (let i = 0; i < finalAdvertisers.length; i++) {
          const advertiser = finalAdvertisers[i];
          const totalShows = advertiser.series.reduce((sum, value) => sum + (value || 0), 0);
          advertisersWithTotals.push({
            ...advertiser,
            totalShows: totalShows,
            index: i
          });
        }

        advertisersWithTotals.sort((a, b) => b.totalShows - a.totalShows);
        const top3Indices = advertisersWithTotals.slice(0, 3).map(a => a.index);

        for (let i = 0; i < finalAdvertisers.length; i++) {
          const advertiser = finalAdvertisers[i];
          const isHidden = !top3Indices.includes(i);

          if (advertiser.id === "combined") {
            fields.push({'key': "Общие данные", 'label':'Общие данные', 'hidden': isHidden})
          } else if (advertiser.id === null) {
            fields.push({'key': "General", 'label':'General', 'hidden': isHidden})
          } else {
            fields.push({'key': `${i}advertiserBrand`, 'label':advertiser.title, 'hidden': isHidden})
          }
        }
        fields.unshift({'key': 'period', 'label':'Период', 'hidden': false})

        for (let i_label = 0; i_label < labels.length; i_label++){
          let item = {"isActive": true, 'period': labels[i_label].split("-").reverse().join(".")}
          for (let i_adv = 0; i_adv < finalAdvertisers.length; i_adv++){
            const advertiser = finalAdvertisers[i_adv];
            if (advertiser.id === "combined") {
              item["Общие данные"] = advertiser.series[i_label]
            } else if (advertiser.id === null) {
              item["General"] = advertiser.series[i_label]
            } else {
              item[`${i_adv}advertiserBrand`] = advertiser.series[i_label]
            }
          }
          items.push(item)
        }
        return {'fields': fields, 'items': items}
    },

    getChartResult(labels, advertisers) {
        this.advertisersLabels = []
        this.chartColours = []
        let datasets = []
        let newAdvertisersLabels = []

        let combinedAdvertiser = null;
        let categoryAdvertiser = null;
        let brandAdvertisers = [];

        for (let i = 0; i < advertisers.length; i++) {
          const advertiser = advertisers[i];
          if (advertiser.id === "combined") {
            combinedAdvertiser = { ...advertiser, index: i };
          } else if (advertiser.id === null) {
            categoryAdvertiser = { ...advertiser, index: i };
          } else {
            const totalShows = advertiser.series.reduce((sum, value) => sum + (value || 0), 0);
            brandAdvertisers.push({
              ...advertiser,
              index: i,
              totalShows: totalShows
            });
          }
        }

        brandAdvertisers.sort((a, b) => b.totalShows - a.totalShows);
        const topBrandAdvertisers = brandAdvertisers.slice(0, 10);

        const finalAdvertisers = [];

        if (combinedAdvertiser) {
          finalAdvertisers.push(combinedAdvertiser);
        }

        if (categoryAdvertiser) {
          finalAdvertisers.push(categoryAdvertiser);
        }

        finalAdvertisers.push(...topBrandAdvertisers);

        // Сначала создаем все датасеты с данными для расчета топ-3
        const datasetsWithTotals = [];

        for (let i = 0; i < finalAdvertisers.length; i++) {
          const advertiser = finalAdvertisers[i];
          let data = advertiser.series;
          let label = advertiser.title;
          let advertiser_type = null;

          if (advertiser.id === "combined") {
            label = 'Общие данные';
            advertiser_type = "combined";
          } else if (advertiser.id === null) {
            label = 'General';
            advertiser_type = "category";
          } else {
            advertiser_type = "brand";
          }

          newAdvertisersLabels.push(label);
          let chartData = [...data];
          chartData.unshift(null);
          chartData.push(null);

          let chartColour = this.getRandomColor(i, advertiser_type);
          this.chartColours.push(chartColour);

          // Вычисляем общую сумму для определения топ-3
          const totalShows = data.reduce((sum, value) => sum + (value || 0), 0);

          datasetsWithTotals.push({
            "data": chartData,
            "label": label,
            "fill": false,
            "borderColor": chartColour,
            "totalShows": totalShows,
            "index": i
          });
        }

        // Сортируем по убыванию показателей и берем топ-3
        datasetsWithTotals.sort((a, b) => b.totalShows - a.totalShows);
        const top3Indices = datasetsWithTotals.slice(0, 3).map(d => d.index);

        // Создаем финальные датасеты с правильным состоянием hidden
        for (let datasetInfo of datasetsWithTotals) {
          datasets.push({
            "data": datasetInfo.data,
            "label": datasetInfo.label,
            "fill": false,
            "borderColor": datasetInfo.borderColor,
            "hidden": !top3Indices.includes(datasetInfo.index)
          });
        }

        let chartLabels = [...labels]
        chartLabels.forEach((label, index) => chartLabels[index] = label.split("-").reverse().join("."))
        chartLabels.unshift(null)
        chartLabels.push(null)

        this.advertisersLabels = newAdvertisersLabels
        return {
          'labels': chartLabels,
          'datasets': datasets
        }
    },



    setGraphData() {
      if (this.wordstatReport) {
        try {
          let apiResponse = this.wordstatReport;
          if (apiResponse["advertisers"]) {
            let labels = apiResponse.chart.labels
            let advertisers = apiResponse.advertisers
            this.period = `с ${labels[0].split("-").reverse().join(".")} пo ${labels[labels.length-1].split("-").reverse().join(".")}`

            let tableResult = this.getTableResult(labels, advertisers)

            this.items = tableResult.items
            this.fields = tableResult.fields

            this.chartData = this.getChartResult(labels, advertisers);

            this.fullChartItems = tableResult.items
            this.fullChartFields = tableResult.fields
            this.selectFullChartFields(tableResult.fields)
            this.selectFullChartItems(tableResult.items)

            return {"chartData": this.chartData, "items": this.items, "fields": this.fields}
          }
        } catch (e) {
          // Error handling
        }
      }
      return {"chartData": null, "items": null, "fields": null}
    },
    ...mapActions("wordstat", ["fetchWordstat", "selectPeriodType", "selectWordstatBrand", "selectWordstatCategory", "selectWordstatCombined", "selectFullChartFields", "selectFullChartItems"]),

    updateLegendVisualState(index, isHidden) {
      const legendElement = document.getElementById('container-element-' + index);
      if (legendElement) {
        const lineElement = legendElement.querySelector('.line');
        const textElement = legendElement.querySelector('p');
        if (lineElement && textElement) {
          lineElement.style.opacity = isHidden ? '0.5' : '1';
          textElement.style.opacity = isHidden ? '0.5' : '1';
        }
      }
    },

    setInitialActiveState() {
      if (this.graphData && this.graphData.chartData && this.graphData.chartData.datasets) {
        this.graphData.chartData.datasets.forEach((dataset, index) => {
          this.updateLegendVisualState(index, dataset.hidden);

          const label = dataset.label;
          if (label === 'Общие данные') {
            this.selectWordstatCombined(!dataset.hidden);
          } else if (label === 'General') {
            this.selectWordstatCategory(!dataset.hidden);
          } else {
            this.selectWordstatBrand(!dataset.hidden);
          }
        });

        this.componentLineChartKey = !this.componentLineChartKey;
      }
    },

    getBrandIndex(label) {
      if (label === 'Общие данные' || label === 'General') {
        return -1;
      }

      let brandIndex = 0;
      for (let i = 0; i < this.graphData.chartData.datasets.length; i++) {
        const dataset = this.graphData.chartData.datasets[i];
        if (dataset.label !== 'Общие данные' && dataset.label !== 'General') {
          if (dataset.label === label) {
            return brandIndex;
          }
          brandIndex++;
        }
      }
      return -1;
    },
  }
}
</script>

<style>
/* Специфичные стили для WSReportContainer - все общие стили перенесены в cards.scss */
</style>
